import { useReducer } from "react"
import { ordenaPorData } from "src/utils/date-format"
import { formatDate } from "src/v2/utils/formatter/date-format"

const initialState = {
    loading: false,
    data: {},
    recentDateFlow: {},
    error: {},
    columns: [
        {
            field: "data_evento",
            headerName: "Data Evento",
            minWidth: 100,
            valueFormatter: (params) =>
                params?.value
                    ? formatDate(params.value?.replace(/-/g, "/"))
                    : "",
        },
        {
            field: "juros_capitalizacao",
            headerName: "Juros Capitalização",

            minWidth: 150,
        },
        {
            field: "juros_tipo",
            headerName: "Tipo Juros",
            minWidth: 100,
        },
        {
            field: "amortizacao_ordinaria",
            headerName: "%Amortização Ordinária",
            minWidth: 150,

            valueFormatter: (params) =>
                Number(params.value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
        },
        {
            field: "amortizacao_extraordinaria",
            headerName: "%Amortização Extraordinária",
            minWidth: 190,

            valueFormatter: (params) =>
                Number(params.value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
        },
        {
            field: "correcao_percentual",
            headerName: "%Correção Indicador",
            minWidth: 150,

            valueFormatter: (params) =>
                Number(params.value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
        },
        {
            field: "taxa_accrual",
            headerName: "%Juros",
            minWidth: 100,

            valueFormatter: (params) =>
                Number(params.value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
        },
        {
            field: "juros_incorporacao_percentual",
            headerName: "%Juros Incorporado",
            minWidth: 130,

            valueFormatter: (params) =>
                Number(params.value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
        },
    ],
}

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING": {
            return {
                ...state,
                loading: action.payload,
            }
        }
        case "SET_DATA":
            return {
                ...state,
                data: { ...state.data, data: action.payload },
                error: { ...state.error, error: {} },
            }
        case "SET_ERROR":
            return { ...state, error: action.payload, data: [] }
        default:
            return state
    }
}

export const useEventFincsTable = (eventFluxService, cetip, baseFlow) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const query = `?cetip__exact=${cetip}&data_evento__asc=true&fluxo_base=${baseFlow}`

    const loadData = async () => {
        if (!cetip || cetip === "") return
        if (!baseFlow) {
            return
        }

        dispatch({ type: "SET_LOADING", payload: true })
        try {
            const response = await eventFluxService.getFincsEventos(query)

            const { body } = response
            const { results } = body
            const data = ordenaPorData(results, "data_evento", "asc")

            const eventos = data.reduce((result, item) => {
                const fluxoBaseKey = `fluxoBase${item.fluxo_base}`
                if (!result[fluxoBaseKey]) {
                    result[fluxoBaseKey] = {
                        description: `Fluxo Base ${item.fluxo_base}`,
                        data: [],
                    }
                }
                const existingData = state.data?.[fluxoBaseKey]?.data || []

                if (!existingData.find((d) => d.id_evento === item.id_evento)) {
                    result[fluxoBaseKey].data.push(item)
                }
                result[fluxoBaseKey].data = [
                    ...existingData,
                    ...result[fluxoBaseKey].data,
                ]

                return result
            }, {})

            dispatch({ type: "SET_DATA", payload: eventos })
        } catch (e) {
            dispatch({ type: "SET_ERROR", payload: e })
        } finally {
            dispatch({ type: "SET_LOADING", payload: false })
        }
    }

    return {
        state,
        actions: {
            loadData,
        },
    }
}
